import en from 'assets/i18n/en.json';
import {useTranslation} from 'react-i18next';

type ENKeys = keyof typeof en;
export type TranslateKey = ENKeys;

export type TranslationFunction = ReturnType<typeof useTranslate>;

export const useTranslate = () => {
  const i18n = useTranslation();
  return (id: TranslateKey, values?: unknown) => {
    return i18n.t(id, {
      defaultValue: `[${id}]`,
      replace: values,
      count: (values as {count?: number})?.count,
    });
  };
};
